import { UserData } from "./user";
import GeneralStore from "@/store/modules/general";

export function initialize(store: any) {
  GeneralStore.initalize(store);
  UserData.initialize();
}
